import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { languageCodes, isRTLLanguage } from './languages';

// Import all English translations for bundling (critical path)
import enCommon from './locales/en/common.json';
import enBuilder from './locales/en/builder.json';
import enRenderer from './locales/en/renderer.json';
import enAuth from './locales/en/auth.json';
import enAdmin from './locales/en/admin.json';
import enValidation from './locales/en/validation.json';
import enFields from './locales/en/fields.json';
import enLiveQuiz from './locales/en/liveQuiz.json';
import enIntegrations from './locales/en/integrations.json';
import enLanding from './locales/en/landing.json';
import enLegal from './locales/en/legal.json';
import enSuperadmin from './locales/en/superadmin.json';
import enMobile from './locales/en/mobile.json';
import enStore from './locales/en/store.json';

const resources = {
  en: {
    common: enCommon,
    builder: enBuilder,
    renderer: enRenderer,
    auth: enAuth,
    admin: enAdmin,
    validation: enValidation,
    fields: enFields,
    liveQuiz: enLiveQuiz,
    integrations: enIntegrations,
    landing: enLanding,
    legal: enLegal,
    superadmin: enSuperadmin,
    mobile: enMobile,
    store: enStore,
  },
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: languageCodes,

    ns: [
      'common',
      'builder',
      'renderer',
      'auth',
      'admin',
      'validation',
      'fields',
      'liveQuiz',
      'integrations',
      'landing',
      'legal',
      'superadmin',
      'mobile',
      'store',
    ],
    defaultNS: 'common',

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already handles escaping
    },

    react: {
      useSuspense: true,
    },

    // Only load languages when needed (lazy loading)
    partialBundledLanguages: true,
  });

// Helper to check if current language is RTL
export const isCurrentLanguageRTL = (): boolean => {
  return isRTLLanguage(i18n.language);
};

// Update document direction when language changes
i18n.on('languageChanged', (lng) => {
  const dir = isRTLLanguage(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
});

export default i18n;
